import { render, staticRenderFns } from "./SmartPtomPlan.vue?vue&type=template&id=7095f480&scoped=true"
import script from "./SmartPtomPlan.vue?vue&type=script&lang=js"
export * from "./SmartPtomPlan.vue?vue&type=script&lang=js"
import style0 from "./SmartPtomPlan.vue?vue&type=style&index=0&id=7095f480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7095f480",
  null
  
)

export default component.exports